import { createFileRoute } from "@tanstack/react-router";

import { ShutdownPage } from "../../features/shutdown";

export const Route = createFileRoute("/_auth/shutdown")({
  component: ShutdownPage,
});
